// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCsPdhLaQjCrRiR2IUTBw1zq-WY_EgI0-0',
    authDomain: 'eventapp-c6bd6.firebaseapp.com',
    databaseURL: 'https://eventapp-c6bd6.firebaseio.com',
    projectId: 'eventapp-c6bd6',
    storageBucket: 'eventapp-c6bd6.appspot.com',
    messagingSenderId: '977181024469'
    }
};




// WEBPACK FOOTER //
// ./src/environments/environment.ts